import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ConnectedDialogModule } from '@morningstar/shared/ui-kit/connected-dialog';
import { HelpVideoIconDialogComponent } from './help-video-icon-dialog/help-video-icon-dialog.component';
import { HelpVideoIconComponent } from './help-video-icon.component';
import { HelpVideoIconService } from './help-video-icon.service';
import { AngularMaterialModule } from '@morningstar/shared/ui-kit/angular-material';

@NgModule({
  declarations: [
    HelpVideoIconComponent,
    HelpVideoIconDialogComponent
  ],
  imports: [
    CommonModule,
    ConnectedDialogModule,
    AngularMaterialModule
  ],
  exports: [
    HelpVideoIconComponent
  ],
  providers: [
    HelpVideoIconService
  ],
  entryComponents: [
    HelpVideoIconDialogComponent
  ]
})
export class HelpVideoIconModule { }
